import RSA from 'jsrsasign';

import { GlobalAPIService } from '@core';
import { Wallet } from '@type';

import { STORE_NAME } from './wallet-store.constant';
import { GetType, SetType } from './wallet-store.type';
import { generateCsr, generateId, generateKeyPair } from './wallet-store.util';

export const setWallet = (set: SetType) => {
  return (wallet: Wallet) => {
    set({ wallet }, false, `${STORE_NAME}-SET_WALLET`);
    return wallet;
  };
};

export const resetWallet = (set: SetType) => () =>
  set({ wallet: undefined }, false, `${STORE_NAME}-RESET_WALLET`);

export const getWallet = (set: SetType, get: GetType) => {
  return async (patientUUID?: string) => {
    const storedWallet = get().wallet;
    if (storedWallet) return storedWallet;

    const { prvKeyObj, pubKeyObj } = generateKeyPair();
    const privateKey = RSA.KEYUTIL.getPEM(prvKeyObj, 'PKCS8PRV');
    const publicKey = RSA.KEYUTIL.getPEM(pubKeyObj);
    const patientBlockchainIdentifier = generateId({ prvKeyObj, pubKeyObj });
    if (!patientUUID)
      patientUUID = await GlobalAPIService.generatePatientUUID();
    const csr = generateCsr(patientUUID, privateKey, publicKey);
    const wallet: Wallet = {
      patientBlockchainIdentifier,
      privateKey,
      publicKey,
      certificate: '',
      patientUuid: patientUUID,
      csr,
    };
    set({ wallet }, false, `${STORE_NAME}-GET-WALLET`);
    return wallet;
  };
};
